export default {
  namespaced: true,

  state: {
    communityOverrides: []
  },

  getters: {
    COMMUNITY_OVERRIDES: state => {
      return state.communityOverrides
    }
  },

  mutations: {
    SET_COMMUNITY_OVERRIDES(state, payload) {
      state.communityOverrides = payload
    }
  },

  actions: {
    setCommunityOverrides(context, value) {
      context.commit('SET_COMMUNITY_OVERRIDES', value)
    }
  }
}
